import { useThemeStore } from '@terminal/components/theme-controller/stores/useThemeStore';
import { isDarkTheme } from '@terminal/components/theme-controller/utils/theme-utils/theme-utils';
import { getCanvasDataUrl } from '@terminal/views/insight-feed/utils/fetchStylesUtils';
import { prepareChartFonts } from './copyAlfredCharts';
import { renderChartNodeToHtml } from './copyChartDom';

const SNAPSHOT_BOTTOM_PADDING_PX = 16;

const replaceCanvasesWithImages = (
  source: HTMLDivElement,
  clone: HTMLDivElement,
  shouldInvertCanvas: boolean
) => {
  const originalCanvases = source.querySelectorAll('canvas');
  const clonedCanvases = clone.querySelectorAll('canvas');

  originalCanvases.forEach((canvas, index) => {
    const clonedCanvas = clonedCanvases[index];

    if (clonedCanvas) {
      const img = document.createElement('img');
      img.src = getCanvasDataUrl(canvas, shouldInvertCanvas);

      const computedStyle = window.getComputedStyle(canvas);
      for (let i = 0; i < computedStyle.length; i += 1) {
        const property = computedStyle.item(i);
        img.style.setProperty(
          property,
          computedStyle.getPropertyValue(property),
          computedStyle.getPropertyPriority(property)
        );
      }
      img.style.width = computedStyle.width;
      img.style.height = computedStyle.height;

      clonedCanvas.parentNode?.replaceChild(img, clonedCanvas);
    }
  });
};

export const renderChartV2Node = async (
  chartNode: HTMLDivElement
): Promise<string> => {
  const shouldInvertCanvas = isDarkTheme(useThemeStore.getState().themeName);
  const fontCss = await prepareChartFonts();

  return renderChartNodeToHtml(chartNode, {
    width: chartNode.offsetWidth,
    height: chartNode.offsetHeight + SNAPSHOT_BOTTOM_PADDING_PX,
    fontCss,
    prepareClone: (clone, source) => {
      clone.style.boxSizing = 'content-box';
      clone.style.height = `${source.offsetHeight}px`;
      clone.style.overflow = 'visible';
      clone.style.paddingBottom = `${SNAPSHOT_BOTTOM_PADDING_PX}px`;

      replaceCanvasesWithImages(source, clone, shouldInvertCanvas);
    },
  });
};
